// let prefix = "";

/* for prod only */
let prefix = "/ssa"

export default prefix;